<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.36 6.56a1.52 1.52 0 00-.8-.87L16 4l-.08-.15a1.56 1.56 0 00-1-.63l-4.31-.76A1.5 1.5 0 009.18 2l-4.39.8a1.5 1.5 0 00-1.22 1.74l2.86 16.23A1.51 1.51 0 007.91 22a1.15 1.15 0 00.26 0l4.4-.77.11-.05a1 1 0 00.88-.54l6.75-12.9a1.56 1.56 0 00.05-1.18zm-7.68 6.68L11.16 4.6l2.93.52zm-7-8.56L9 4.08l2.69 15.25-3.41.6zm8.85 9.94l1.4-8.42 2.35 1.1z"/><circle cx="9.63" cy="17.38" r="1"/></svg>